export const LIGHTNING_DAILY_MAX = 12;
export const LIGHTNING_REWARD = 1;
export const LIGHTNING_SHOP_NO = 0;
export const SNACK_STORAGE_MAX = 999;

export const SNACK_SHOP_NOTICES = [
  '간식 충전소의 구성과 지급 간식 수량은 운영 정책에 따라 변경될 수 있어요.',
  '간식 충전은 자정 기준으로 횟수가 초기화돼요.',
  '간식은 최대 999개까지 보관 가능하며, 초과 시 새로 획득한 간식은 지급되지 않아요.',
  '비정상적인 이용(예: 본인 계정으로 초대하거나, 자동화 도구 사용 등)이 확인될 경우, 사전 고지 없이 이용이 제한될 수 있어요.',
  '간식 충전 영상은 네트워크 상태에 따라 재생이 원활하지 않을 수 있으며, 광고 미노출 시 간식이 지급되지 않을 수 있어요.',
];

export function toClockValue(date = new Date()) {
  return date.getHours() * 10000 + date.getMinutes() * 100 + date.getSeconds();
}

export function isWithinWindow(now, startAt, endAt) {
  const start = Number(startAt) || 0;
  const end = Number(endAt) || 0;
  const current = Number(now) || 0;
  if (start <= end) return current >= start && current <= end;
  return current >= start || current <= end;
}

export function slotPhase(now, startAt, endAt) {
  if (isWithinWindow(now, startAt, endAt)) return 'open';
  const start = Number(startAt) || 0;
  const end = Number(endAt) || 0;
  const current = Number(now) || 0;
  if (start <= end) return current < start ? 'upcoming' : 'closed';
  if (current > end && current < start) return 'upcoming';
  return 'closed';
}

export function maxClaimCount(item) {
  const reward = Number(item?.rewardCount) || 0;
  const maxCount = Number(item?.maxCount) || 0;
  if (reward <= 0 || maxCount < reward) return 0;
  return maxCount - reward + 1;
}

export function remainingClaimCount(item) {
  return Math.max(0, maxClaimCount(item) - Math.max(0, Number(item?.userCount) || 0));
}

export function maxSnackCount(item) {
  return maxClaimCount(item) * (Number(item?.rewardCount) || 0);
}

export function remainingSnackCount(item) {
  return remainingClaimCount(item) * (Number(item?.rewardCount) || 0);
}

export function formatClockLabel(value) {
  const clock = Number(value) || 0;
  const hours = Math.floor(clock / 10000);
  const minutes = Math.floor((clock % 10000) / 100);
  if (hours === 0 && minutes === 0) return '자정';

  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  const period = hours < 6 ? '새벽' : hours < 12 ? '오전' : '오후';
  const minuteText = minutes === 0 ? '' : ` ${minutes}분`;
  return `${period} ${hour12}시${minuteText}`;
}

export function formatWindowLabel(startAt, endAt) {
  return `${formatClockLabel(startAt)} ~ ${formatClockLabel(endAt)}`;
}
